import React from "react";

const Loader = ({ type = "" }) => {
  if (!["products", "articles"].includes(type.toLowerCase())) {
    return (
      <div className={`afd-story afd-story--loading widget-loader--${type.toLowerCase()}`} />
    );
  }

  return (
    <div
      className="myad-recommendations-widget"
    >
      <h2
        className="afd-title-big afd-title-big--bmargin-big loading-animation"
        style={{ width: 400, maxWidth: "100%", height: 32 }}
      />
      <ul
        className="myad-desktop-margin myad-bookmark-grid myad-bookmark-grid--recommendations"
      >
        {[1, 2, 3].map((item) => (
          <div key={`loader-${type}-${item}`}>
            <figure className="myad-bookmark-grid__item myad-bookmark-grid__item--loading loading-animation" />
            <div className="myad-search-list__title loading-animation" style={{ width: "100%", height: 21 }} />
            <div className="myad-search-list__subtitle loading-animation" style={{ width: "50%", height: 16 }} />
          </div>))}
      </ul>
    </div>
  );
};

export default Loader;
